import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class MoStackedAccordion extends Vue {
  @Prop({ required: true })
  isOpen: boolean
}
